import React from 'react';
import SadIcon from './SadIcon';
import { useTranslation } from '../hooks/useTranslation';
export function NoResultSection() {
    const title = useTranslation('noResultsFoundTitle');
    const description = useTranslation('noResultsFoundDescription');
    return (React.createElement("div", { className: "WhSearch-NoResultSection" },
        React.createElement("div", { className: "WhSearch-NoResultSection__icon" },
            React.createElement(SadIcon, null)),
        React.createElement("div", { className: "WhSearch-NoResultSection__header" }, title),
        React.createElement("div", { className: "WhSearch-NoResultSection__description" }, description)));
}
//# sourceMappingURL=NoResultSection.js.map